import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class WindowService {
  public getWindow() {
    return window;
  }

  public getDocumentOrigin(): string {
    if (window?.document?.location) {
      return window.document.location.origin;
    } else {
      return undefined;
    }
  }
}
